<template>
  <span>
    <div style="width: 60%" class="mx-auto">
      <b-form @submit="boxDetails">
        <div class="form-group mb-3 input-group input-text-wrapper">
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon
                icon="sort-numeric-down"
                style="color: #ced4da"
              />
            </span>
          </div>
          <b-form-select
            class="box-text-input"
            v-model="form.post_office_station"
            required
          >
            <b-select-option :value="null"
              >Choose Post Office Station</b-select-option
            >
            <b-select-option
              v-for="branch in getPostOffices"
              :key="branch"
              :value="branch.branch_id"
            >
              {{ branch.name }}
            </b-select-option>
          </b-form-select>
        </div>

        <div class="form-group mb-3 input-group input-text-wrapper">
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="square" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="form.box_number"
            type="tel"
            required
            placeholder="Box Number"
          ></b-form-input>
        </div>

        <div class="form-group mb-3 input-group input-text-wrapper">
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="money-bill" style="color: #ced4da" />
            </span>
          </div>
          <b-form-select
            v-model="form.payment_period"
            :options="payment_period_list"
            class="box-text-input"
            required
          >
          </b-form-select>
        </div>

        <div class="form-group mb-3 input-group input-text-wrapper">
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="credit-card" style="color: #ced4da" />
            </span>
          </div>
          <b-form-select
            v-model="form.payment_mode"
            :options="payment_mode_items"
            class="box-text-input"
            required
          >
          </b-form-select>
        </div>

        <br />

        <button
          class="form-control boxDetails button"
          style="margin-bottom: 4%"
          type="submit"
        >
          Next
          <b-spinner
            v-if="boxDetailsSpinner"
            label="Loading..."
            small
          ></b-spinner>
        </button>
      </b-form>
    </div>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BoxDetails",
  data() {
    return {
      boxDetailsSpinner: false,
      form: {
        post_office_station: null,
        box_number: null,
        payment_period: null,
        payment_mode: null,
      },
      box_size_items: [
        { value: null, text: "Select Box Size" },
        { value: "small", text: "Small" },
        { value: "big", text: "Big" },
      ],
      payment_period_list: [
        { value: null, text: "Select Payment Period" },
        { value: "1year", text: "1 Year" },
        { value: "2years", text: "2 Years" },
        { value: "3years", text: "3 Years" },
        { value: "4years", text: "4 Years" },
      ],

      payment_mode_items: [
        { value: null, text: "Select Payment Mode" },
        { value: "mobile_money", text: "Mobile Money" },
        { value: "visa_master_card", text: "VISA/Mastercard" },
      ],
      remark_items: [
        { value: null, text: "Remark" },
        { value: "box_allocation", text: "New Box Allocation" },
        { value: "none", text: "None" },
        { value: "other", text: "Other" },
      ],
    };
  },
  computed: {
    ...mapGetters(["getPostOffices"]),
  },
  methods: {
    ...mapActions(["fetchPostOffices"]),
    boxDetails(env) {
      env.preventDefault();

      //alert(JSON.stringify(this.form))
      this.$emit("boxDetails", this.form);
      this.$emit("goTo", 3);
    },
  },
  mounted() {
    this.fetchPostOffices();
  },
};
</script>

<style scoped>
.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 13px;
  height: 13vm;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}

.boxDetails {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 4%;
}
</style>
